<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M15.2 13.4211H0.8C0.587827 13.4211 0.384344 13.5042 0.234315 13.6523C0.0842854 13.8003 0 14.0011 0 14.2105C0 14.4199 0.0842854 14.6207 0.234315 14.7688C0.384344 14.9168 0.587827 15 0.8 15H15.2C15.4122 15 15.6157 14.9168 15.7657 14.7688C15.9157 14.6207 16 14.4199 16 14.2105C16 14.0011 15.9157 13.8003 15.7657 13.6523C15.6157 13.5042 15.4122 13.4211 15.2 13.4211ZM8 0C7.78783 0 7.58434 0.0831764 7.43431 0.231231C7.28429 0.379286 7.2 0.580092 7.2 0.789474V9.15L4.568 6.54474C4.41736 6.39608 4.21304 6.31256 4 6.31256C3.78696 6.31256 3.58264 6.39608 3.432 6.54474C3.28136 6.6934 3.19673 6.89503 3.19673 7.10526C3.19673 7.3155 3.28136 7.51713 3.432 7.66579L7.432 11.6132C7.50637 11.6872 7.59485 11.7459 7.69234 11.786C7.78983 11.826 7.89439 11.8467 8 11.8467C8.10561 11.8467 8.21017 11.826 8.30766 11.786C8.40515 11.7459 8.49363 11.6872 8.568 11.6132L12.568 7.66579C12.6426 7.59218 12.7018 7.50479 12.7421 7.40862C12.7825 7.31244 12.8033 7.20936 12.8033 7.10526C12.8033 7.00116 12.7825 6.89808 12.7421 6.80191C12.7018 6.70573 12.6426 6.61835 12.568 6.54474C12.4934 6.47113 12.4049 6.41274 12.3074 6.3729C12.2099 6.33306 12.1055 6.31256 12 6.31256C11.8945 6.31256 11.7901 6.33306 11.6926 6.3729C11.5951 6.41274 11.5066 6.47113 11.432 6.54474L8.8 9.15V0.789474C8.8 0.580092 8.71571 0.379286 8.56569 0.231231C8.41566 0.0831764 8.21217 0 8 0Z"
      fill="#71757F"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'DownloadIcon'
})
</script>